<template>
	<b-modal
		id="modal-menu"
		size="sidebar"
		hide-backdrop
		hide-footer
		no-close-on-backdrop
		no-fade
		dialog-class="theme-dark"
		header-border-variant="dark"
		scrollable
	>
		<template #modal-header="{ close }">
			<div :class="dynamicContainer">
				<div
					class="py-2 row d-flex justify-center no-gutters"
				>
					<a
						href="javascript:void(null);"
						:aria-label="$t('searchVar')"
						class="d-flex align-items-center"
						@click="$bvModal.show('search-modal')"
					>
						<span class="icon icon-search" />
					</a>

					<!-- Emulate built in modal header close button action -->
					<div class="col-auto ml-auto">
						<b-button
							variant="transparent"
							size="md"
							class="icon-close"
							@click="close()"
						/>
					</div>
				</div>

				<div class="sidebar-divider mt-0" />

				<div class="row flex-column no-gutters btn-panel">
					<!-- LK -->
					<div
						v-if="$auth.loggedIn"
						class="mb-2 mb-lg-4 d-flex justify-content-between align-items-center"
					>
						<nuxt-link
							:to="{
								name: 'user-profile',
								query: { item: 'MainInfo' },
								params: { redirectUrl: $route.fullPath },
							}"
							class="d-flex align-items-center relative"
						>
							<b-img-lazy
								v-if="$auth.user.avatar_url"
								:src="$auth.user.avatar_url"
								blank-color="lightgray"
								style="
									object-fit: cover;
									width: 30px !important;
									height: 30px !important;
								"
								class="mr-4 rounded-circle align-self-center position-absolute left-0"
							/>
							<div class="inner-container pr-0 d-flex align-items-center">
								{{ $auth.user.first_name || $auth.user.email }}
								{{ $auth.user.last_name }}
							</div>
						</nuxt-link>
						<nuxt-link
							:to="{
								name: 'user-profile',
								query: { item: 'MainInfo' },
								params: { redirectUrl: $route.fullPath },
							}"
							class="d-flex align-items-center"
						>
							<span class="mr-2">Личный кабинет</span>
							<ArrowNext class="lk-arrow" />
						</nuxt-link>
					</div>

					<div v-else class="avatar">
						<a
							href="javascript:void(null);"
							:aria-label="$t('login')"
							@click="handleProfileClick"
						>
							<span
								class="icon icon-private d-flex align-self-center mr-4"
							/>
						</a>
					</div>
					<!-- LK/ -->
					<div class="inner-container">
						<a v-if="loyaltyProfile && !isLoyaltyProfileFetching" href="/user/profile/loyalty/card/">
							{{ $points(roundedPointsSum) }} баллов лояльности
						</a>
					</div>
				</div>

				<div class="sidebar-divider mb-0" />
			</div>
		</template>
		<div class="container">
			<div class="row mt-0">
				<div class="col-12 col-sm-12 mt-4">
					<div class="inner-container">
						<ul class="list-unstyled modal-menu-list">
							<li
								v-for="item in navigation"
								:key="item.path"
								class="navigation"
							>
								<a :href="item.path">{{ item.title }}</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="sidebar-divider" />

			<div class="inner-container mb-2 mb-lg-5">
				<template v-if="languageSwitchLink && !disableRedirect">
					<a
						v-for="locale in availableLocales"
						:key="locale.code"
						role="button"
						class="lang_switch"
						@click="$i18n.setLocale(locale.code)"
					>
						<span class="mr-4 text-uppercase">{{
							locale.name
						}}</span>
					</a>
				</template>
			</div>
			<div class="inner-container">
				<template v-for="(action, key) in actionsList">
					<nuxt-link
						v-if="action.path"
						:key="action.path"
						:to="action.path"
						class="w-100 btn btn-secondary mb-3 mb-lg-4"
					>
						{{ action.title }}
					</nuxt-link>
					<div
						v-else
						:key="`${key}-callback`"
						class="w-100 btn btn-secondary mb-3 mb-lg-4"
						@click="action.callback"
					>
						{{ action.title }}
					</div>
				</template>
			</div>
		</div>
	</b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import IconArrowRight from '~/static/svg/icon-arrow-right.vue';
import ArrowNext from '~/static/svg/arrow-next.vue';

export default {
	name: 'SidebarMenu',
	components: { ArrowNext, IconArrowRight },
	props: {
		roundedPointsSum: {
			type: Number,
			default: 0,
		},
		loyaltyProfile: {
			type: Object,
			default: () => ({}),
		},
		availableLocales: {
			type: Array,
			default: () => [],
		},
		languageSwitchLink: {
			type: String,
			default: '',
		},
		dynamicContainer: {
			type: String,
			default: '',
		},
		disableRedirect: {
			type: Boolean,
			default: false,
		},
		isLoyaltyProfileFetching: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		navigation() {
			const prefix = this.$i18n.locale === 'en' ? '/en' : '';
			return [
				{
					path: `${prefix}/navigator/programmes/`,
					title: this.$t('programmes'),
				},
				{
					path: `${prefix}/navigator/events/`,
					title: this.$t('events'),
				},
				{
					path: `${prefix}/faculty/`,
					title: this.$t('professors'),
				},
				{
					path: `${prefix}/research/`,
					title: this.$t('research'),
				},
				{
					path: `${prefix}/intrend/`,
					title: 'inTrend',
				},
				{
					path: `${prefix}/alumni/`,
					title: 'Alumni',
				},
				{
					path: `${prefix}/about-school/`,
					title: this.$t('aboutSchool'),
				},
				{
					path: `${prefix}/campus/`,
					title: this.$t('campus'),
				},
				{
					path: `${prefix}/about-school/contacts/`,
					title: this.$t('contacts'),
				},
			];
		},
		actionsList() {
			return [
				{
					path: '/loyalty-system/',
					title: 'Программа лояльности',
					callback: () => {},
				},
				{
					path: '/donation/',
					title: 'Поддержать Школу',
					callback: () => {},
				},
			];
		},
	},
	methods: {
		...mapActions({
			showLoginPopup: 'authModal/showLogin',
		}),
		showSkolkovoIdPopup() {
			const params = `?return_url=${window.location.origin}${this.$route.fullPath}`;

			window.location.replace(`https://sk.skolkovo.ru/test_skolkovo_id_redirect${params}`);
		},
		handleProfileClick() {
			if (process.env.disabledProfile) {
				this.showSkolkovoIdPopup();
				return;
			}
			this.showLoginPopup();
		},
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.modal-menu,
.menu_panel {
	.logo-khust {
		display: block;
		height: 3.5rem;
		background: url("/frontimg/SKOLKOVO-HKUST-logo.png") left center
			no-repeat;
		background-size: contain;
		width: 12rem;
		left: -0.5rem;
		position: relative;

		@include media-breakpoint-up(sm) {
			width: 14rem;
		}
	}

	.logo-yandex {
		display: block;
		height: 3.5rem;
		background: url("/frontimg/SKOLKOVO_YP.png") left center no-repeat;
		background-size: contain;
		width: 12rem;
		left: -0.5rem;
		position: relative;

		@include media-breakpoint-up(sm) {
			width: 14rem;
		}
	}

	.logo-stories {
		display: block;
		height: 3.5rem;
		background: url("/frontimg/skolkovo-stories.png") left center no-repeat;
		background-size: contain;
		width: 12rem;
		left: -0.5rem;
		position: relative;

		@include media-breakpoint-up(sm) {
			width: 14rem;
		}
	}

	.logo-ProductCamp {
		display: block;
		height: 3.5rem;
		background: url("/frontimg/ProductCamp.png") left center no-repeat;
		background-size: contain;
		width: 12rem;
		left: -0.5rem;
		position: relative;

		@include media-breakpoint-up(sm) {
			width: 14rem;
		}
	}

	.logo-atlanty {
		display: block;
		height: 3.5rem;
		background: url("/frontimg/SkolkovoAtlanty.png") left center no-repeat;
		background-size: contain;
		width: 12rem;
		left: -0.5rem;
		position: relative;

		@include media-breakpoint-up(sm) {
			width: 14rem;
		}
	}

	.logo-lean {
		display: block;
		height: 3.5rem;
		background: url("/frontimg/SKOLKOVO_LEAN.png") left center no-repeat;
		background-size: contain;
		width: 12rem;
		left: -0.5rem;
		position: relative;

		@include media-breakpoint-up(sm) {
			width: 14rem;
		}
	}

	.logo-alfa {
		display: block;
		height: 3.5rem;
		background: url("/frontimg/SK-en+ALFA.png") left center no-repeat;
		background-size: contain;
		width: 12rem;
		left: -0.5rem;
		position: relative;

		@include media-breakpoint-up(sm) {
			width: 14rem;
		}
	}

	.logo {
		display: block;
		height: 2.5rem;
		// логитип десктоп
		// background: url('/frontimg/skolkovo_15y_white.svg') left center no-repeat;
		// width: 7rem;
		// логотип-иконка (только в вертикальном мобильном варианте)
		// background: url('/frontimg/logo_icon.svg') left center no-repeat;
		background: url("/frontimg/skolkovo_logo.png") left center no-repeat;
		background-size: contain;
		width: 9rem;

		@include media-breakpoint-up(sm) {
			width: 10rem;
		}
	}
}

.modal-menu-list {
	display: flex;
	flex-direction: column;
	gap: 1rem;

	& > li {
		font-size: 1rem;
	}
}
/**/
.modal-sidebar {
	.icon-close {
		padding: 0;
	}
}

.inner-container {
	padding: 0 5rem;

	@include media-breakpoint-down(lg) {
		padding: 0 4rem;
	}
}

.sidebar-divider {
	margin: 1rem 0;
	width: 100%;
	height: 1px;
	background-color: #e2e2e24d;
	opacity: 0.3;
}

.lang_switch {
	cursor: pointer;
}

.lk-arrow {
	width: 1rem;
	height: 1rem;
	color: $white;
}

.avatar {
	font-size: 1.5rem;
}
</style>
